var React = require('react');

function MenuBtn (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"48.94","y":"136.783","width":"402.121","height":"44.564","key":0}),React.createElement("rect",{"x":"48.94","y":"227.967","width":"402.121","height":"44.564","key":1}),React.createElement("rect",{"x":"48.94","y":"319.149","width":"402.121","height":"44.564","key":2})]);
}

MenuBtn.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 500 500","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = MenuBtn;

MenuBtn.default = MenuBtn;
